// 此文件已废弃，i18n 配置已移至 src/plugins/i18n.ts
// 保留此文件仅为兼容性考虑
import { LanguageEnum } from '@/enums/appEnum';
import { i18n } from '@/plugins/i18n';

export { i18n as default } from '@/plugins/i18n';

export const languageOptions = [
  { value: LanguageEnum.ZH, label: '简体中文' },
  { value: LanguageEnum.EN, label: 'English' }
];

/**
 * 翻译函数类型
 */
interface Translation {
  (key: string): string;
}
/**
 * 全局翻译函数
 * 可在任何地方使用，无需导入 useI18n
 */
export const $t = i18n.global.t as Translation;